module.exports = __webpack_public_path__ + "static/img/reward.a9fd7e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reward.png
// module id = bGX3
// module chunks = 34